import React, {useEffect, useRef} from "react";

interface Props {
  html: string;
  className?: string;
}

export const RawHTML = ({html, className}: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = html;
    }
  }, [html]);

  return <div ref={ref} className={className}/>;
}